<!-- <div class="row bloccodati"> -->
  <!-- <div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Tipo richiedente'"
    [valueInput]="ctxBodyFascicolo.fascicolo.tipoRichiedente ? 'Interno' : 'Esterno'"></div> -->
  <!-- <div labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Oggetto'" [valueInput]="ctxBodyFascicolo.fascicolo.oggetto"></div>
  <div labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Società'" [valueInput]="ctxBodyFascicolo.fascicolo.societa?.nome"></div> -->
<!-- </div> -->
<div class="row bloccodati">

</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label for="quesito_richiesta">Quesito/richiesta</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.richiesta }}</span>
    </p>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label>Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
